export default "__VITE_ASSET__68nqUb8e__"